import { useState } from "react";
import type { UsRulesKey } from "../types";
import { Hint } from "./Hint";

const KEY = "insidera.usRules";

export const US_RULES: { key: UsRulesKey; label: string; help: string }[] = [
  {
    key: "B2",
    label: "По книге",
    help:
      "Сетап книги «две силы» (гл. 13, с. 151 и 162): коммерсанты у края диапазона (COT 26 выше 80 или WILLCO 80 и выше — " +
      "покупка, зеркально продажа) и 52-недельная средняя цены идёт в ту же сторону. Стоп — фиксированная сумма в долларах на " +
      "контракт, в крупном тренде — минимум 17 дней, перевход по максимуму 13 дней (гл. 12). Лучший вариант по правилу, " +
      "записанному до бэктеста.",
  },
  {
    key: "B",
    label: "Книга + OI",
    help:
      "То же, что «По книге», плюс третья сила гл. 15: открытый интерес низкий для покупок (стохастик OI за год 20 и ниже) и " +
      "высокий для продаж (80 и выше). У индексов OI не учитывается (гл. 8). Сделок меньше.",
  },
  {
    key: "C",
    label: "Сетап 4+",
    help:
      "Правила Мосбиржи «Сетап 4+ · 3 ATR»: балл из 5 — тренд по 39-недельной средней, коммерсанты, OI, сезонность и мелкие " +
      "трейдеры против; вход, когда балл впервые 4 или 5; стоп 3 ATR.",
  },
];

export function loadUsRules(): UsRulesKey {
  try {
    const v = localStorage.getItem(KEY);
    return v === "B" || v === "C" ? v : "B2";
  } catch {
    return "B2";
  }
}

/** Выбор набора правил США; выбор запоминается в браузере. */
export function useUsRules(): [UsRulesKey, (r: UsRulesKey) => void] {
  const [rules, set] = useState<UsRulesKey>(loadUsRules);
  const setRules = (r: UsRulesKey) => {
    set(r);
    try {
      localStorage.setItem(KEY, r);
    } catch {
      /* без сохранения выбора */
    }
  };
  return [rules, setRules];
}

export function UsRulesSwitch({ rules, onChange }: { rules: UsRulesKey; onChange: (r: UsRulesKey) => void }) {
  const cur = US_RULES.find((x) => x.key === rules) ?? US_RULES[0];
  return (
    <div className="list-tools">
      <div className="seg" role="group" aria-label="Правила сделок США">
        <span className="seg-label">
          Правила <Hint label="Что за правила">{cur.help}</Hint>
        </span>
        <div className="segmented">
          {US_RULES.map((x) => (
            <button
              key={x.key}
              type="button"
              className={rules === x.key ? "active" : undefined}
              aria-pressed={rules === x.key}
              onClick={() => onChange(x.key)}
              title={x.help}
            >
              {x.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export function usd(v: number | null | undefined): string {
  if (v == null || !Number.isFinite(v)) return "—";
  const s = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 0 }).format(Math.abs(v));
  return `${v < 0 ? "−" : ""}$${s}`;
}

export function pf(v: number | null | undefined): string {
  if (v == null || !Number.isFinite(v) || v === 0) return "—";
  return v >= 99 ? "∞" : v.toFixed(2).replace(".", ",");
}
